import { render } from "./GroupAccessAdminsModal.vue?vue&type=template&id=4962e50c&scoped=true"
import script from "./GroupAccessAdminsModal.vue?vue&type=script&lang=js"
export * from "./GroupAccessAdminsModal.vue?vue&type=script&lang=js"

import "./GroupAccessAdminsModal.vue?vue&type=style&index=0&id=4962e50c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4962e50c"]])

export default __exports__